// Destinations animation functionality
export const initDestinationAnimation = () => {
  const destinations = ['Spiti', 'Ladakh', 'Kashmir', 'Tawang'];
  let currentIndex = 0;
  const destinationElement = document.querySelector('.destination-text');
  
  if (destinationElement) {
    setInterval(() => {
      fadeOut(destinationElement, () => {
        destinationElement.textContent = destinations[(currentIndex + 1) % destinations.length];
        currentIndex = (currentIndex + 1) % destinations.length;
        fadeIn(destinationElement);
      });
    }, 5000);
  }
};

// Fade animations helper functions
export const fadeOut = (element, callback) => {
  let opacity = 1;
  const timer = setInterval(() => {
    if (opacity <= 0.1) {
      clearInterval(timer);
      element.style.opacity = 0;
      if (callback) callback();
    }
    element.style.opacity = opacity;
    opacity -= opacity * 0.1;
  }, 20);
};

export const fadeIn = (element) => {
  let opacity = 0;
  element.style.opacity = opacity;
  const timer = setInterval(() => {
    if (opacity >= 1) {
      clearInterval(timer);
    }
    element.style.opacity = opacity;
    opacity += 0.1;
  }, 20);
};

// Bottom navigation active state handling
export const setupBottomNav = () => {
  const bottomNavItems = document.querySelectorAll('.bottom-nav-item');
  
  bottomNavItems.forEach(item => {
    item.addEventListener('click', function(e) {
      e.preventDefault();
      bottomNavItems.forEach(navItem => {
        navItem.classList.remove('active');
      });
      this.classList.add('active');
    });
  });
};

// Testimonial carousel functionality
export const setupTestimonialCarousel = () => {
  const testimonials = document.querySelectorAll('.testimonial-card');
  let testimonialIndex = 0;
  
  if (testimonials.length > 1) {
    // Show only the first testimonial initially
    testimonials.forEach((card, index) => {
      if (index !== 0) {
        card.style.display = 'none';
      }
    });
    
    // Auto-scroll testimonials
    setInterval(() => {
      testimonials[testimonialIndex].style.display = 'none';
      testimonialIndex = (testimonialIndex + 1) % testimonials.length;
      testimonials[testimonialIndex].style.display = 'block';
    }, 8000);
  }
};

// Initialize all interactive features
export const initializeInteractiveFeatures = () => {
  document.addEventListener('DOMContentLoaded', () => {
    initDestinationAnimation();
    setupBottomNav();
    setupTestimonialCarousel();
  });
};